<template>
    <v-container fluid>
        <v-layout justify-center>
            <v-flex md12>
                <DataTableMainServer
                :datatable="tableServer"
                :on-success="successAction"
                :itemsAction="tableAction"
                :on-pagination="pagePagination"
                :on-search="getSearchPagePagination"/>
            </v-flex>
        </v-layout>
        <DialogSurvey v-if="get_dialogMain.dialog" :model="person"/>
        <DialogImportData v-if="get_dialogSecoundMain.dialog" />
    </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DialogSurvey from '@/components/dialogs/SurveyPersonDialog'
import DialogImportData from '@/components/dialogs/imports/ImportDataDialog'
import DataTableMainServer from '@/components/tables/DataTableMainServer'
import XLSX from 'xlsx'
import router from '@/router'
export default {
  data: () => ({
    tableServer: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', pagination: {}, code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'person.update' },
          { title: 'Importar', icon: 'mdi-account-multiple-plus', color: 'warning', action: 'importData', code: 'person.importar' },
          {
            title: 'REPORTES',
            color: 'light-blue lighten-1',
            icon: 'mdi-cloud-download',
            options: [
              { title: 'Municipios Federal Sexo', icon: 'mdi-clipboard-text', action: 'ExportTodos' },
              { title: 'Municipios Federal Edad', icon: 'mdi-clipboard-text', action: 'ExportFederalEdad' },
              { title: 'Municipios Local Sexo', icon: 'mdi-clipboard-text', action: 'ExportLocalSexo' },
              { title: 'Municipios Local Edad', icon: 'mdi-clipboard-text', action: 'ExportLocalEdad' },
              { title: 'Encuesta 1', icon: 'mdi-clipboard-text', action: 'ExportEncuesta' }
            ],
            code: 'person.getresumendatos'
          }
        ],
        titles: [
          { text: 'Nombre', value: 'NombreCompleto', class: 'black--text' },
          { text: 'Edad', value: 'Edad', sortable: false, class: 'black--text' },
          { text: 'Sexo', value: 'sexo', sortable: false, class: 'black--text' },
          { text: 'Direccion', value: 'DireccionCompleta', sortable: false, class: 'black--text' },
          { text: 'Telefono', value: 'datos.contacto.telefono', sortable: false, class: 'black--text' },
          { text: 'Celular', value: 'datos.contacto.movil', sortable: false, class: 'black--text' },
          // { text: 'Correo', value: 'datos.contacto.correo', class: 'black--text' },
          { text: 'Municipio', value: 'municipio.nombre', class: 'black--text' },
          { text: 'DF', value: 'federal.nombre', class: 'black--text' },
          { text: 'DE', value: 'local.nombre', class: 'black--text' },
          { text: 'Categoria', value: 'Categoria', sortable: false, class: 'black--text' },
          // { text: 'Afiliacion', value: 'ife', class: 'black--text' },
          { text: 'Encuestas Atendidas', value: 'EncuestasResultado', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        totalData: 0,
        actions: [
          { title: 'Encuesta', icon: 'mdi-clipboard-text', color: 'lime lighten-1', action: 'toEncuetas', code: 'person.storerespuestas' },
          { title: 'Editar', icon: 'mdi-border-color', color: 'lime lighten-1', action: 'toEdit', code: 'person.update' },
          { title: 'Detalles', icon: 'mdi-backburger', color: 'lime lighten-1', action: 'toDetails', code: 'libre', hidden: '' }
        ],
        pagination: {}
      },
      footer: {
        paging: true
      }
    },
    person: {},
    pages: {}
  }),
  components: {
    DataTableMainServer,
    DialogSurvey,
    DialogImportData
  },
  mounted () {
    this.ShowPermisos(JSON.parse(localStorage.getItem('permisos')))
  },
  methods: {
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.tableServer.header.loading = true
      this.pages = item.pagination
      // console.log('pagination', val)
      this.getUrl('person.paginacion')
    },
    newData (item) {
      router.push({ name: 'ViewCreatePersonas' })
    },
    importData (item) {
      this.SHOW_DIALOG_SECOUND_MAIN({ type: 'create' })
    },
    ExportTodos (item) {
      console.log('ExportTodos', item)
      this.getUrlExport({ route: 'person.getresumendatos', data: 'federal/Municipio/S' })
    },
    ExportFederalEdad (item) {
      console.log('ExportFederalEdad', item)
      this.getUrlExport({ route: 'person.getresumendatos', data: 'federal/Municipio/E' })
    },
    ExportLocalEdad (item) {
      console.log('ExportLocalEdad', item)
      this.getUrlExport({ route: 'person.getresumendatos', data: 'local/Municipio/E' })
    },
    ExportLocalSexo (item) {
      console.log('ExportLocalSexo', item)
      this.getUrlExport({ route: 'person.getresumendatos', data: 'local/Municipio/S' })
    },
    ExportEncuesta (item) {
      const data = XLSX.utils.json_to_sheet(this.encuesta)
      const workbook = XLSX.utils.book_new()
      // const nameHours = this.getDateAndHour()
      const filename = 'Encuesta1'
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },
    /* *==========*==========*==========*==========*==========* */
    tableAction (item) {
      this[item.action](item)
    },
    toEncuetas (item) {
      this.person = item.item
      this.SHOW_DIALOG_MAIN({ type: 'create' })
    },
    toEdit (item) {
      router.push({ name: 'ViewEditPersonas', params: { id: item.item.id } })
    },
    /* *==========*==========*==========*==========*==========* */
    pagePagination (val) {
      this.tableServer.header.loading = true
      this.pages = val
      // console.log('pagination', val)
      this.getUrl('person.paginacion')
    },
    getSearchPagePagination (val) {
      this.tableServer.header.loading = true
      this.pages = val
      this.getUrl('person.filter')
    },
    /* *==========*==========*==========*==========*==========* */
    ...mapActions(['getUrlServices', 'getUrlServicesAction', 'postUrlServicesPaginationAction', 'getUrlServicesExportAction']),
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postUrlServicesPaginationAction({ url: router, data: this.pages })
      } else {
        this.getUrlServices()
      }
    },
    getUrlExport (objet) {
      let router = this.get_urls[objet.route]
      router = router.replace('{A1}/{A2}/{A3}', objet.data)
      this.getUrlServicesExportAction(router)
      router = router.replace(objet.data, '{A1}/{A2}/{A3}')
    },
    getDateAndHour () {
      const date = new Date()
      const day = date.getDay()
      const month = ((date.getMonth() + 1) < 10) ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1).toString()
      const year = date.getFullYear()
      const hours = date.getHours()
      const minutes = date.getMinutes()
      const secunds = date.getSeconds()
      return `_${year}${month}${day}${hours}${minutes}${secunds}`
    },
    ShowPermisos (permisos) {
      if (permisos.descripcion) {
        if (permisos.descripcion.special === 'all-access') {
          this.tableServer.header.options.map(action => {
            action.hidden = ''
          })
          this.tableServer.body.actions.map(action => {
            action.hidden = ''
          })
        } else {
          this.tableServer.header.options.map(action => {
            permisos.permisos.map(item => {
              if (action.code !== 'libre') {
                if (action.code === item.slug) {
                  action.hidden = ''
                }
              }
            })
          })

          this.tableServer.body.actions.map(action => {
            permisos.permisos.map(item => {
              if (action.code !== 'libre') {
                if (action.code === item.slug) {
                  action.hidden = ''
                }
              }
            })
          })
        }
      } else {
        this.tableServer.header.options.map(action => {
          permisos.permisos.map(item => {
            if (action.code !== 'libre') {
              if (action.code === item.slug) {
                action.hidden = ''
              }
            }
          })
        })

        this.tableServer.body.actions.map(action => {
          permisos.permisos.map(item => {
            if (action.code !== 'libre') {
              if (action.code === item.slug) {
                action.hidden = ''
              }
            }
          })
        })
      }
    },
    ...mapMutations(['SHOW_DIALOG_MAIN', 'SHOW_DIALOG_SECOUND_MAIN', 'CLEAR_DATAS_MAIN'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_dialogSecoundMain', 'get_urls', 'get_objectsExport', 'get_objectPagination'])
  },
  watch: {
    get_urls () {
      this.getUrl('person.paginacion')
      // this.getUrl('GET/militantes/get')
    },
    get_objectPagination (val) {
      if (val) {
        // console.log('data', val)
        this.tableServer.header.loading = false
        this.tableServer.body.totalData = val.total
        this.tableServer.body.data = val.data
      }
    },
    get_objectsExport (vals) {
      if (vals) {
        const data = XLSX.utils.json_to_sheet(vals.data)
        const workbook = XLSX.utils.book_new()
        // const nameHours = this.getDateAndHour()
        const filename = vals.name
        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`)
      }
    }

  },
  beforeDestroy () {
    this.CLEAR_DATAS_MAIN()
  }
}
</script>

<style>
</style>
